// Configuration - Define VIP variants and free product
const CONFIG = {
  vipVariants: [
    '44993481179409', '49135343567121', '52723794116881', '52723794772241', '52723800768785',
    // Annual membership (hero-vip-club-year-option): Bronze, Silver, Gold
    '53648073949457', '53648073982225', '53648074014993'
  ],
  freeProductVariant: '50012331082001',
  sellingPlans: {
    '49135343567121': 5911052561,
    '44993481179409': 4502356241,
    '52723794116881': 12879495441,
    '52723794772241': 12879528209,
    '52723800768785':12879560977,
    '53648073949457': 5911052561,
    '53648073982225': 13267534097,
    '53648074014993': 13267566865
  },
  discountCodes: {
    // Theme settings > VIP Club – Products > VIP discount code
    vipMember: (window.PXUTheme && window.PXUTheme.vip_discount_code) || 'VIPMEMBEROFF',
    // Placeholder that clears any code left on the cart session (fallback only)
    nonVipMember: 'ADD_VIP_PRODUCT_TO_THE_CART_FOR_DISCOUNT'
  },
  // The Unlocked Offers and VIP Unlock pages are chosen in
  // Theme settings > VIP Unlock flow (see unlockFlowSettings below).
  redirects: {
    cart: '/cart',
    checkout: '/checkout'
  }
};




// State management to prevent race conditions
let isProcessing = false;
let lastCartUpdate = 0;
const CART_UPDATE_DEBOUNCE = 500;

// Set while a deliberate VIP removal is mid-flight. The sync loop re-adds the
// free product (and re-attaches selling plans to the membership) whenever a VIP
// variant is present, so it must stand down while the user is tearing the whole
// bundle out — otherwise an in-flight repair call resurrects the line between
// the removal call and the redirect.
let isRemoving = false;

// Set when adding the free bracelet fails (usually sold out). Every failed
// add is itself a cart request that triggers another sync, so without this
// the sync would retry in a tight loop.
let freeProductUnavailable = false;

// Line keys whose selling plan couldn't be re-attached, for the same reason
const sellingPlanRepairFailed = new Set();

// Watches for cart requests from any script (see watchCartRequests). Lifted to
// module scope so removeVipProductsFromCart() can stop watching the moment a
// removal starts — setting isRemoving alone only blocks syncs that haven't
// started yet.
let cartRequestObserver = null;

// Console logging for debugging the VIP scripts. Off unless the page URL has
// ?vipdebug (remembered for the rest of the tab session).
const VIP_DEBUG = (function() {
  try {
    if (/[?&]vipdebug\b/.test(window.location.search)) {
      sessionStorage.setItem('vipdebug', '1');
    }
    return sessionStorage.getItem('vipdebug') === '1';
  } catch (error) {
    return false;
  }
})();

function debugLog(...args) {
  if (VIP_DEBUG) console.log(...args);
}

// Helper function to safely convert to string and handle null/undefined
function safeString(value) {
  return value ? String(value) : '';
}

// Helper function to check if cart contains a VIP variant
function cartContainsVipVariant(cart) {
  try {
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      return false;
    }
    
    return cart.items.some(item => {
      try {
        return item && CONFIG.vipVariants.includes(safeString(item.variant_id));
      } catch (e) {
        console.warn('Error checking VIP variant for item:', item, e);
        return false;
      }
    });
  } catch (error) {
    console.error('Error in cartContainsVipVariant:', error);
    return false;
  }
}

// Helper function to get VIP variant count
function getVipVariantCount(cart) {
  try {
    if (!cart || !Array.isArray(cart.items)) return 0;
    
    return cart.items.reduce((count, item) => {
      try {
        if (item && CONFIG.vipVariants.includes(safeString(item.variant_id))) {
          return count + (parseInt(item.quantity) || 0);
        }
        return count;
      } catch (e) {
        console.warn('Error counting VIP variants for item:', item, e);
        return count;
      }
    }, 0);
  } catch (error) {
    console.error('Error in getVipVariantCount:', error);
    return 0;
  }
}

// Helper function to check if cart contains the free product and return detailed info
function cartContainsFreeProduct(cart) {
  try {
    if (!cart || !Array.isArray(cart.items)) {
      return { exists: false, quantity: 0, items: [] };
    }
    
    const freeProductItems = cart.items.filter(item => {
      try {
        return item && safeString(item.variant_id) === CONFIG.freeProductVariant;
      } catch (e) {
        console.warn('Error checking free product for item:', item, e);
        return false;
      }
    });
    
    const totalQuantity = freeProductItems.reduce((sum, item) => {
      try {
        return sum + (parseInt(item.quantity) || 0);
      } catch (e) {
        console.warn('Error calculating quantity for item:', item, e);
        return sum;
      }
    }, 0);
    
    return {
      exists: freeProductItems.length > 0,
      quantity: totalQuantity,
      items: freeProductItems,
      itemCount: freeProductItems.length
    };
  } catch (error) {
    console.error('Error in cartContainsFreeProduct:', error);
    return { exists: false, quantity: 0, items: [], itemCount: 0 };
  }
}

// Function to check if a VIP variant has a selling plan
function vipVariantHasSellingPlan(cart) {
  try {
    if (!cart || !Array.isArray(cart.items)) return false;
    
    const vipItems = cart.items.filter(item => 
      item && CONFIG.vipVariants.includes(safeString(item.variant_id))
    );
    
    return vipItems.some(item => {
      return item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan_id;
    });
  } catch (error) {
    console.error('Error in vipVariantHasSellingPlan:', error);
    return false;
  }
}

// Function to get VIP items without selling plans
function getVipItemsWithoutSellingPlans(cart) {
  try {
    if (!cart || !Array.isArray(cart.items)) return [];
    
    return cart.items.filter(item => {
      return item && 
        CONFIG.vipVariants.includes(safeString(item.variant_id)) &&
        (!item.selling_plan_allocation || !item.selling_plan_allocation.selling_plan_id);
    });
  } catch (error) {
    console.error('Error in getVipItemsWithoutSellingPlans:', error);
    return [];
  }
}

// Function to fetch cart with retry logic and error handling
function withCart(callback, retries = 3) {
  return fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(cart => {
      // Validate cart structure
      if (!cart || typeof cart !== 'object') {
        throw new Error('Invalid cart data received');
      }
      
      // Ensure items is an array
      if (!Array.isArray(cart.items)) {
        cart.items = [];
      }
      
      return callback(cart);
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
      
      if (retries > 0) {
        debugLog(`Retrying cart fetch, ${retries} attempts remaining`);
        return new Promise(resolve => {
          setTimeout(() => {
            resolve(withCart(callback, retries - 1));
          }, 1000);
        });
      }
      
      // Fallback: call callback with empty cart
      console.warn('Using fallback empty cart');
      return callback({ items: [], total_price: 0, item_count: 0 });
    });
}

// Function to update cart with validation and error handling
function updateCart(updates) {
  if (!updates || typeof updates !== 'object') {
    console.error('Invalid updates object:', updates);
    return Promise.reject(new Error('Invalid updates'));
  }
  
  // Validate updates - ensure all values are numbers
  const validatedUpdates = {};
  for (const [key, value] of Object.entries(updates)) {
    const numValue = parseInt(value);
    if (!isNaN(numValue) && numValue >= 0) {
      validatedUpdates[key] = numValue;
    } else {
      console.warn(`Invalid quantity for variant ${key}: ${value}, skipping`);
    }
  }
  
  if (Object.keys(validatedUpdates).length === 0) {
    console.warn('No valid updates to apply');
    return Promise.resolve({});
  }
  
  debugLog('Updating cart with:', validatedUpdates);
  
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates: validatedUpdates })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then(result => {
    lastCartUpdate = Date.now();
    return result;
  })
  .catch(error => {
    console.error('Error updating cart:', error);
    throw error;
  });
}

// Function to change cart item with selling plan
function changeCartItemWithSellingPlan(id, quantity = 1, sellingPlan = null) {
  // A removal is in progress — do not re-attach selling plans (which would
  // re-establish the membership line the user is removing).
  if (isRemoving) {
    debugLog('VIP removal in progress, skipping selling-plan change');
    return Promise.resolve(null);
  }

  // Validate inputs
  if (!id) {
    console.error('No product ID provided');
    return Promise.reject(new Error('Product ID is required'));
  }
  
  const validQuantity = parseInt(quantity);
  if (isNaN(validQuantity) || validQuantity < 1) {
    console.error('Invalid quantity:', quantity);
    return Promise.reject(new Error('Valid quantity is required'));
  }
  
  const data = {
    id: safeString(id),
    quantity: validQuantity
  };
  
  if (sellingPlan) {
    const validSellingPlan = parseInt(sellingPlan);
    if (!isNaN(validSellingPlan)) {
      data.selling_plan = validSellingPlan;
    }
  }
  
  debugLog('Changing cart item:', data);
  
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then(result => {
    lastCartUpdate = Date.now();
    return result;
  })
  .catch(error => {
    console.error('Error changing item in cart:', error);
    throw error;
  });
}

// Function to add item to cart with validation
function addToCart(id, quantity = 1, selling_plan = null) {
  // A removal is in progress — do not re-add anything (free product or
  // otherwise) until the page reloads.
  if (isRemoving) {
    debugLog('VIP removal in progress, skipping add to cart');
    return Promise.resolve(null);
  }

  // Validate inputs
  if (!id) {
    console.error('No product ID provided');
    return Promise.reject(new Error('Product ID is required'));
  }
  
  const validQuantity = parseInt(quantity);
  if (isNaN(validQuantity) || validQuantity < 1) {
    console.error('Invalid quantity:', quantity);
    return Promise.reject(new Error('Valid quantity is required'));
  }
  
  const data = {
    id: safeString(id),
    quantity: validQuantity
  };
  
  if (selling_plan) {
    const validSellingPlan = parseInt(selling_plan);
    if (!isNaN(validSellingPlan)) {
      data.selling_plan = validSellingPlan;
    }
  }
  
  debugLog('Adding to cart:', data);
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then(result => {
    lastCartUpdate = Date.now();
    return result;
  })
  .catch(error => {
    console.error('Error adding item to cart:', error);
    throw error;
  });
}

// Adds the free bracelet; stops trying for this page view if it can't be added
function addFreeProduct() {
  if (freeProductUnavailable) return Promise.resolve(null);

  return addToCart(CONFIG.freeProductVariant, 1)
    .catch(error => {
      console.warn('Free product could not be added (sold out?), not retrying:', error);
      freeProductUnavailable = true;
      return null;
    });
}

// Enhanced function to synchronize the free product with VIP status and selling plans
function syncFreeProductWithVipStatus() {
  if (isRemoving) {
    debugLog('VIP removal in progress, skipping sync');
    return Promise.resolve();
  }

  if (isProcessing) {
    debugLog('Sync already in progress, skipping');
    return Promise.resolve();
  }
  
  // Debounce rapid calls
  const now = Date.now();
  if (now - lastCartUpdate < CART_UPDATE_DEBOUNCE) {
    debugLog('Debouncing sync call');
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(syncFreeProductWithVipStatus());
      }, CART_UPDATE_DEBOUNCE);
    });
  }
  
  isProcessing = true;
  
  return withCart(cart => {
    try {
      const hasVipVariant = cartContainsVipVariant(cart);
      const vipVariantCount = getVipVariantCount(cart);
      const freeProductInfo = cartContainsFreeProduct(cart);
      const hasSellingPlan = vipVariantHasSellingPlan(cart);
      // Lines whose repair already failed are left alone (see sellingPlanRepairFailed)
      const vipItemsWithoutSellingPlans = getVipItemsWithoutSellingPlans(cart)
        .filter(item => !sellingPlanRepairFailed.has(item.key));
      
      debugLog('Cart Sync Analysis:', {
        hasVipVariant,
        vipVariantCount,
        freeProductExists: freeProductInfo.exists,
        freeProductQuantity: freeProductInfo.quantity,
        freeProductItemCount: freeProductInfo.itemCount,
        hasSellingPlan,
        vipItemsWithoutSellingPlansCount: vipItemsWithoutSellingPlans.length
      });
      
      // Case 0: Has VIP products but no selling plan - ADD selling plan
      if (hasVipVariant && vipItemsWithoutSellingPlans.length > 0) {
        debugLog('Adding selling plan to VIP variants');
        
        const promises = vipItemsWithoutSellingPlans.map(item => {
          const variantId = safeString(item.variant_id);
          const sellingPlan = CONFIG.sellingPlans[variantId];
          
          if (sellingPlan) {
            debugLog(`Adding selling plan ${sellingPlan} to variant ${variantId}`);
            return changeCartItemWithSellingPlan(
              item.key || item.id, // Use line item key or id
              item.quantity,
              sellingPlan
            ).catch(error => {
              console.error(`Failed to add selling plan to variant ${variantId}, not retrying:`, error);
              sellingPlanRepairFailed.add(item.key);
              return null;
            });
          }
          return Promise.resolve();
        });
        
        return Promise.all(promises)
          .then(() => {
            debugLog('All selling plans processed, now checking free product');
            // After adding selling plans, check free product status again
            return withCart(updatedCart => {
              const updatedFreeProductInfo = cartContainsFreeProduct(updatedCart);
              const updatedHasVipVariant = cartContainsVipVariant(updatedCart);
              
              // Now handle free product logic
              if (updatedHasVipVariant && !updatedFreeProductInfo.exists) {
                debugLog('Adding free product to cart after selling plan update');
                return addFreeProduct();
              }
              return Promise.resolve(updatedCart);
            });
          });
      }
      
      // Case 1: Has VIP products but no free product - ADD free product
      if (hasVipVariant && !freeProductInfo.exists && !freeProductUnavailable) {
        debugLog('Adding free product to cart (missing)');
        return addFreeProduct();
      }
      
      // Case 2: Has VIP products but wrong quantity of free product - CORRECT quantity
      // (also consolidates duplicate free product lines, whose total is > 1)
      if (hasVipVariant && freeProductInfo.exists && freeProductInfo.quantity !== 1) {
        debugLog(`Correcting free product quantity from ${freeProductInfo.quantity} to 1`);
        const updates = {};
        updates[CONFIG.freeProductVariant] = 1;
        return updateCart(updates)
          .catch(error => {
            console.error('Failed to correct free product quantity:', error);
            return null;
          });
      }
      
      // Case 3: No VIP products but has free product - REMOVE free product
      if (!hasVipVariant && freeProductInfo.exists) {
        debugLog('Removing free product from cart (no VIP products)');
        const updates = {};
        updates[CONFIG.freeProductVariant] = 0;
        return updateCart(updates)
          .catch(error => {
            console.error('Failed to remove free product:', error);
            return null;
          });
      }
      
      // Case 4: Everything is correct - no action needed
      debugLog('Cart sync: No changes needed');
      return Promise.resolve(cart);
      
    } catch (error) {
      console.error('Error in sync logic:', error);
      return Promise.resolve(cart);
    }
  })
  .finally(() => {
    isProcessing = false;
  });
}


// Function to checkout with appropriate discount based on VIP status
// The answer to the holiday priority shipping question, as soon as it's
// chosen (saving it on the cart is asynchronous)
let priorityAnswer = null;

// Every discount code that applies to this cart:
// - the VIP code when the cart has a VIP membership
// - the priority shipping code when the shopper answered "No", while that
//   question and its discount are on (Theme settings > Cart – Holiday
//   priority shipping)
// They're applied together. For more than one to count, each code must be
// set to combine with the others in Shopify admin (Discounts > code >
// Combinations); otherwise Shopify keeps only one.
// Codes the shopper applied themselves (e.g. from a campaign link) are kept.
function checkoutDiscountsFor(cart) {
  const priority = (window.PXUTheme && window.PXUTheme.priority_shipping) || {};
  const answer = priorityAnswer || (cart.attributes && cart.attributes.priorityshipping);

  // Codes this script manages are re-decided below, never carried over
  const managed = [CONFIG.discountCodes.vipMember, CONFIG.discountCodes.nonVipMember, priority.discount_code]
    .filter(Boolean)
    .map(code => code.toUpperCase());
  const codes = (cart.discount_codes || [])
    .map(discount => discount.code)
    .filter(code => code && !managed.includes(code.toUpperCase()));

  if (cartContainsVipVariant(cart)) {
    codes.push(CONFIG.discountCodes.vipMember);
  }
  if (priority.active && priority.discount_code && answer === 'No') {
    codes.push(priority.discount_code);
  }
  return codes;
}

// Puts exactly these codes on the cart; they carry through to checkout. An
// empty list clears any code left on the cart session.
function applyCartDiscounts(codes) {
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ discount: codes.join(',') })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  });
}

// Saves the priority shipping answer on the cart (priorityshipping attribute,
// so it reaches the order; the checkout buttons skip the cart form) and
// re-decides the discount codes in the same update: "No" adds the priority
// shipping code, "Yes" takes it off. Other codes stay (checkoutDiscountsFor).
function savePriorityAnswer(answer) {
  return withCart(cart => fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: { priorityshipping: answer },
      discount: checkoutDiscountsFor(cart).join(',')
    })
  }).then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  }))
  .then(() => {
    document.querySelectorAll('[data-saved-answer]').forEach(field => {
      field.setAttribute('data-saved-answer', answer);
    });
  })
  .catch(error => {
    console.warn('Could not save priority shipping answer:', error);
  });
}

function checkoutWithDiscounts() {
  return withCart(cart => {
    const codes = checkoutDiscountsFor(cart);
    debugLog('Checking out with discounts:', codes);

    return applyCartDiscounts(codes)
      .then(() => {
        window.location.href = CONFIG.redirects.checkout;
      })
      .catch(error => {
        console.warn('Could not apply discounts to the cart, passing them to checkout instead:', error);
        const discount = codes.length ? codes.join(',') : CONFIG.discountCodes.nonVipMember;
        window.location.href = `/cart/checkout?discount=${encodeURIComponent(discount)}`;
      });
  });
}

// Enhanced function to handle VIP variant addition to cart
function addVipVariantToCart(variantId) {
  if (!variantId) {
    console.error('No variant ID provided for VIP product');
    return Promise.reject(new Error('Variant ID is required'));
  }
  
  // Validate variant ID is actually a VIP variant
  if (!CONFIG.vipVariants.includes(safeString(variantId))) {
    console.error('Invalid VIP variant ID:', variantId);
    return Promise.reject(new Error('Invalid VIP variant'));
  }
  
  jQuery("body").addClass("disabled-active");
  
  const sellingPlan = CONFIG.sellingPlans[variantId];
  let operationSuccessful = false;
  
  return addToCart(variantId, 1, sellingPlan)
    .then(result => {
      debugLog('VIP product added successfully:', result);
      operationSuccessful = true;
      
      // Wait a moment for cart to update, then sync free product
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(syncFreeProductWithVipStatus());
        }, 500);
      });
    })
    .then(() => {
      if (operationSuccessful) {
        // Joining from the unlock pages on the way to checkout carries on to
        // checkout; otherwise land on the cart.
        const destination = unlockCheckoutPending() ? CONFIG.redirects.checkout : CONFIG.redirects.cart;
        debugLog('VIP product added, redirecting to', destination);
        window.location.href = vipDiscountUrl(destination);
      }
    })
    .catch(error => {
      console.error('Error adding VIP variant to cart:', error);
      
      // Show user-friendly error message
      if (typeof $ !== 'undefined' && $.alert) {
        $.alert({
          title: 'Error',
          content: 'There was an issue adding the product to your cart. Please try again.',
          buttons: {
            OK: function() {}
          }
        });
      } else {
        alert('There was an issue adding the product to your cart. Please try again.');
      }
    })
    .finally(() => {
      jQuery("body").removeClass("disabled-active");
    });
}

// Function to remove VIP products from cart with confirmation
// Removes the VIP membership and its free bracelet. From the mini cart the
// shopper stays on the page and the mini cart re-renders; from the cart page
// it reloads the cart page.
function removeVipProductsFromCart(fromMiniCart = false) {
  // Stop the sync from re-adding the bracelet (or re-attaching the
  // membership's selling plan) while we tear the bundle out. The flag blocks
  // new syncs and the addToCart/changeCartItemWithSellingPlan guards, and
  // disconnecting stops our own removal calls from triggering more syncs.
  isRemoving = true;
  if (cartRequestObserver) {
    cartRequestObserver.disconnect();
    cartRequestObserver = null;
  }

  const finish = () => {
    if (!fromMiniCart) {
      window.location.href = CONFIG.redirects.cart;
      return Promise.resolve();
    }

    // Staying on the page: back to normal syncing
    isRemoving = false;
    watchCartRequests();
    return refreshMiniCart()
      .then(openMiniCart)
      .catch(error => {
        console.error('Could not refresh mini cart after removing VIP:', error);
        window.location.reload();
      });
  };

  // The membership is a subscription line (it carries a selling plan).
  // /cart/update.js keyed by VARIANT ID rejects selling-plan lines with a 422,
  // and because the update is atomic the whole call fails and nothing is removed
  // — which is exactly why "Remove" appeared to do nothing. Remove by line-item
  // KEY instead, which works for both plain and selling-plan lines. Fetch the
  // live cart so we can resolve the key for every VIP variant and the bracelet.
  return withCart(cart => {
    const updates = {};
    (cart.items || []).forEach(item => {
      const variantId = safeString(item.variant_id);
      if (CONFIG.vipVariants.includes(variantId) || variantId === CONFIG.freeProductVariant) {
        updates[item.key] = 0;
      }
    });

    debugLog('Removing VIP products by line key:', updates);
    if (Object.keys(updates).length === 0) {
      return finish();
    }

    return updateCart(updates)
      // Re-decide the cart's discount codes without the membership: drops the
      // VIP code, keeps the shopper's own codes and the priority shipping one.
      .then(() => withCart(updatedCart => applyCartDiscounts(checkoutDiscountsFor(updatedCart))))
      .catch(error => {
        console.error('Error removing VIP products:', error);
      })
      .then(finish);
  });
}

// Enhanced debounce function with immediate execution option
function debounce(func, wait, immediate = false) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      timeout = null;
      if (!immediate) func(...args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func(...args);
  };
}

const debouncedSync = debounce(syncFreeProductWithVipStatus, 300);

// Lets other cart UI (cart-rewards-bar.js) redraw after the cart changes
function announceCartChange() {
  document.dispatchEvent(new CustomEvent('hero:cart:changed'));
}

// Keeps the mini cart in step when anything changes the cart, e.g. Wi BOGO
// adding the free gift or BOGO items while the mini cart is open. The
// section render it fetches isn't a cart change, so this can't loop.
const debouncedMiniCartRefresh = debounce(() => {
  if (!document.querySelector('[data-cart-form="mini-cart"]')) return;
  refreshMiniCart().catch(error => {
    console.warn('Could not refresh mini cart after a cart change:', error);
  });
}, 400);

// Re-syncs after any request that changes the cart — from the theme, GemPages
// or apps. Resource timing reports every fetch/XHR the page makes, so this
// sees them all without wrapping fetch or polling /cart.js.
const CART_CHANGE_PATH = /\/cart\/(add|change|update|clear)(\.js)?$/;

function watchCartRequests() {
  if (!('PerformanceObserver' in window)) {
    console.warn('PerformanceObserver unavailable; VIP cart sync runs on page load only');
    return;
  }

  try {
    cartRequestObserver = new PerformanceObserver(list => {
      const cartPaths = list.getEntries()
        .filter(entry => entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest')
        .map(entry => {
          try {
            return new URL(entry.name).pathname;
          } catch (error) {
            return '';
          }
        })
        .filter(path => CART_CHANGE_PATH.test(path));

      if (cartPaths.length) {
        debugLog('Cart change request detected');
        debouncedSync();
        announceCartChange();
        debouncedMiniCartRefresh();
      }
      if (cartPaths.some(path => /\/cart\/add/.test(path))) {
        onDonationAdded();
      }
    });
    cartRequestObserver.observe({ type: 'resource' });
  } catch (error) {
    console.warn('Could not watch cart requests:', error);
  }
}

// Safe element selector with error handling
function safeGetElement(selector) {
  try {
    return document.querySelector(selector);
  } catch (error) {
    console.warn('Error selecting element:', selector, error);
    return null;
  }
}

// Safe value extraction with fallback
function safeGetValue(element, attribute = 'value', fallback = '') {
  try {
    if (!element) return fallback;
    
    if (attribute === 'value') {
      return element.value || fallback;
    } else {
      return element.getAttribute(attribute) || fallback;
    }
  } catch (error) {
    console.warn('Error getting element value:', error);
    return fallback;
  }
}

// /discount/<VIP code>?redirect=<path> applies the VIP discount to the session
function vipDiscountUrl(redirectPath) {
  return `/discount/${encodeURIComponent(CONFIG.discountCodes.vipMember)}?redirect=${redirectPath}`;
}

// Adds a theme product form's selection to the cart: variant, quantity,
// selling plan (Loop subscriptions) and line item properties.
function addFormToCart(form) {
  if (isRemoving) {
    debugLog('VIP removal in progress, skipping add to cart');
    return Promise.resolve(null);
  }

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Accept': 'application/json' },
    body: new FormData(form)
  })
  .then(response => response.json().then(data => {
    if (!response.ok) {
      throw data;
    }
    return data;
  }))
  .then(result => {
    lastCartUpdate = Date.now();
    return result;
  });
}

// Same warning style app.js uses for add-to-cart errors
function showAddToCartWarning(form, message) {
  $('.warning').remove();
  const $warning = $('<p class="warning animated bounceIn"></p>').text(message);
  if (form) {
    $(form).after($warning);
  } else {
    alert(message);
  }
}

// ---------------------------------------------------------------------------
// VIP Unlock flow
//
// Decides where shoppers go after Add to Cart and which unlock pages
// (Unlocked Offers, VIP Unlock) they see on the way to checkout. Everything is
// configured in Theme settings > VIP Unlock flow and handed to this script by
// snippets/js-variables.liquid as window.PXUTheme.unlock_flow.
// ---------------------------------------------------------------------------
const UNLOCK_STEPS = ['offers', 'vip'];
const UNLOCK_STEPS_BY_SETTING = {
  offers_then_vip: ['offers', 'vip'],
  vip: ['vip'],
  offers: ['offers'],
  none: []
};
const UNLOCK_STATE_KEY = 'heroUnlockFlow';
// After this long an abandoned trip through the unlock pages stops steering
// their "continue" buttons to checkout.
const UNLOCK_CHECKOUT_TTL = 30 * 60 * 1000;
const MINI_CART_PARTS = ['.js-cart_items', '.js-cart_priority_shipping', '.js-cart_vip_offer', '.js-cart_discounts', '.js-cart_subtotal', '.js-cart_savings'];

function unlockFlowSettings() {
  const settings = (window.PXUTheme && window.PXUTheme.unlock_flow) || {};
  return {
    afterAdd: settings.after_add || 'mini_cart',
    steps: UNLOCK_STEPS_BY_SETTING[settings.checkout_steps] || [],
    frequency: settings.frequency || 'session',
    urls: { offers: settings.offers_url, vip: settings.vip_url },
    currentStep: settings.current_step || null,
    customerIsVip: !!settings.customer_is_vip
  };
}

// Per-tab state: { seen: { offers: true }, checkout: { startedAt } }
function readUnlockState() {
  try {
    return JSON.parse(sessionStorage.getItem(UNLOCK_STATE_KEY)) || {};
  } catch (error) {
    return {};
  }
}

function writeUnlockState(state) {
  try {
    sessionStorage.setItem(UNLOCK_STATE_KEY, JSON.stringify(state));
  } catch (error) {
    console.warn('Could not save unlock flow state:', error);
  }
}

function unlockCheckoutPending() {
  const { checkout } = readUnlockState();
  return !!checkout && Date.now() - checkout.startedAt < UNLOCK_CHECKOUT_TTL;
}

// Unlock pages still to show for this cart, in order. VIP Unlock is skipped
// for shoppers who are already members, and with "Once per visit" each page
// is shown only once per browser tab.
function unlockStepsFor(cart) {
  const { steps, frequency, customerIsVip, urls } = unlockFlowSettings();
  const seen = (frequency === 'session' && readUnlockState().seen) || {};
  const isVip = customerIsVip || cartContainsVipVariant(cart);
  return steps.filter(step => urls[step] && !seen[step] && !(step === 'vip' && isVip));
}

// Re-renders the mini cart from the header section so it matches the Liquid
// version exactly (hidden VIP bracelet, VIP remove button, cart count).
function refreshMiniCart() {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  return fetch(`${root}?sections=header`)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(sections => {
      const fresh = new DOMParser().parseFromString(sections.header || '', 'text/html');
      const freshForm = fresh.querySelector('[data-cart-form="mini-cart"]');
      if (!freshForm) {
        throw new Error('Mini cart missing from header section');
      }
      const freshContent = freshForm.closest('.cart_content');
      const isEmpty = freshForm.classList.contains('hidden');

      // Only the inner parts are swapped so handlers bound to the mini cart
      // itself (continue shopping, hover open/close) keep working.
      document.querySelectorAll('.cart_content').forEach(content => {
        const form = content.querySelector('[data-cart-form="mini-cart"]');
        if (!form) return;

        MINI_CART_PARTS.forEach(selector => {
          const from = freshContent.querySelector(selector);
          const to = content.querySelector(selector);
          if (from && to) to.innerHTML = from.innerHTML;
        });

        form.classList.toggle('hidden', isEmpty);
        $(form).data('total-discount', freshForm.getAttribute('data-total-discount'));

        const emptyMessage = content.querySelector('.js-empty-cart__message');
        if (emptyMessage) emptyMessage.classList.toggle('hidden', !isEmpty);
      });

      const count = Array.from(fresh.querySelectorAll('.cart_count'))
        .map(el => el.textContent.trim())
        .find(Boolean);
      if (count) {
        document.querySelectorAll('.cart_count').forEach(el => { el.textContent = count; });
      }

      if (window.PXUTheme.currency.show_multiple_currencies && window.currencyConverter) {
        window.currencyConverter.convertCurrencies();
      }

      announceCartChange();
    });
}

// Same container choice app.js used to make after an AJAX add
function openMiniCart() {
  let $cartContainer;
  if ($('#header').is(':visible')) {
    $cartContainer = $('#header .cart-container');
  } else if ($('.sticky_nav--stick').length) {
    $cartContainer = $('.sticky_nav .cart-container');
  } else {
    $cartContainer = $('.top-bar .cart-container');
  }

  if ($('body').hasClass('fancybox-active')) {
    $.fancybox.close();
  }

  $('.dropdown_link').removeClass('active_link');
  $cartContainer.addClass('active_link');

  if (window.PXUTheme.media_queries.medium.matches) {
    $('body').addClass('blocked-scroll');

    // Scroll to the top of the page unless the header is fixed
    const header = document.getElementById('header');
    if (header && header.classList.contains('mobile_nav-fixed--false')) {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
  }
}

// Called once a product is in the cart (theme forms, GemPages buttons, app.js)
function afterAddToCart() {
  const { afterAdd, urls } = unlockFlowSettings();

  if (afterAdd === 'offers_page' && urls.offers) {
    window.location.href = urls.offers;
    return Promise.resolve();
  }

  // The cart page has no mini cart; reloading it shows the new item
  if (afterAdd === 'cart_page' || !document.querySelector('[data-cart-form="mini-cart"]')) {
    window.location.href = CONFIG.redirects.cart;
    return Promise.resolve();
  }

  return refreshMiniCart()
    .then(openMiniCart)
    .catch(error => {
      console.error('Could not refresh mini cart, going to cart page:', error);
      window.location.href = CONFIG.redirects.cart;
    });
}

// Final hop to checkout, with the discounts from checkoutDiscountsFor
function proceedToCheckout() {
  const state = readUnlockState();
  delete state.checkout;
  writeUnlockState(state);
  return checkoutWithDiscounts();
}

// Checkout clicked in the mini cart or on the cart page
function startCheckout() {
  const { urls } = unlockFlowSettings();

  return withCart(cart => {
    const steps = unlockStepsFor(cart);
    if (!steps.length) {
      return proceedToCheckout();
    }

    const state = readUnlockState();
    state.checkout = { startedAt: Date.now() };
    writeUnlockState(state);
    window.location.href = urls[steps[0]];
  });
}

// "No thanks" / "I'm done" on an unlock page: the next unlock page, then
// checkout if the shopper came from checkout, otherwise the cart.
function continueUnlockFlow(fromStep) {
  const { urls } = unlockFlowSettings();
  const fromIndex = UNLOCK_STEPS.indexOf(fromStep);

  return withCart(cart => {
    const next = unlockStepsFor(cart).find(step => UNLOCK_STEPS.indexOf(step) > fromIndex);
    if (next) {
      window.location.href = urls[next];
      return;
    }

    if (unlockCheckoutPending()) {
      return proceedToCheckout();
    }

    window.location.href = cartContainsVipVariant(cart) ? vipDiscountUrl(CONFIG.redirects.cart) : CONFIG.redirects.cart;
  });
}

// On an unlock page, these mean "continue": the theme's continue button
// ([data-unlock-continue]) and plain links to /cart in the page content, such
// as the "No thanks, take me to the cart" buttons built in GemPages.
function isUnlockContinueLink(link) {
  if (link.hasAttribute('data-unlock-continue')) return true;
  if (link.tagName !== 'A' || link.closest('header, footer, .cart-container, .cart_content')) return false;

  try {
    const url = new URL(link.href, window.location.href);
    return url.pathname.replace(/\/$/, '') === CONFIG.redirects.cart;
  } catch (error) {
    return false;
  }
}

// Unlocked Offers page: once something is added, the continue button reads
// "I'm done" instead of "No thanks".
function markOfferAdded() {
  document.querySelectorAll('[data-unlock-continue][data-done-label]').forEach(el => {
    el.textContent = el.getAttribute('data-done-label');
  });
}

// ---------------------------------------------------------------------------
// VIP mini cart offer (snippets/mini-cart-vip-offer.liquid)
//
// Shoppers pick a plan (Bronze / Silver / Gold, optionally monthly or yearly)
// and tick the checkbox to add it. The membership goes in with its selling
// plan, plus the free bracelet when it was in stock at render time, and the
// VIP discount is applied so the mini cart shows it straight away. The
// re-rendered mini cart no longer includes the offer.
// ---------------------------------------------------------------------------
function selectedVipPlan(offer) {
  const tiers = offer.querySelector('[data-vip-tiers]:not([hidden])');
  return tiers && tiers.querySelector('input[type="radio"]:checked');
}

// Shows the chosen plan's description and names it next to the checkbox
function updateVipOffer(offer) {
  const plan = selectedVipPlan(offer);
  const text = offer.querySelector('[data-vip-tier-text]');
  const label = offer.querySelector('[data-vip-optin-plan]');

  if (text) text.textContent = plan ? plan.getAttribute('data-tier-text') : '';
  if (label) label.textContent = plan ? `${plan.getAttribute('data-tier-name')} ${plan.getAttribute('data-tier-price')}` : '';
}

function showVipOfferError(offer, message) {
  const error = offer.querySelector('[data-vip-offer-error]');
  if (!error) return;
  error.textContent = message;
  error.hidden = !message;
}

// Shows the VIP discount (and the priority shipping one, if it applies) in
// the mini cart straight away
function applyVipDiscount() {
  return withCart(cart => applyCartDiscounts(checkoutDiscountsFor(cart)))
    .catch(error => {
      // Checkout applies them anyway (checkoutWithDiscounts)
      console.warn('Could not apply VIP discount to the cart:', error);
    });
}

function addVipPlanFromOffer(offer, checkbox) {
  const plan = selectedVipPlan(offer);
  if (!plan) {
    checkbox.checked = false;
    showVipOfferError(offer, 'Please choose a membership level.');
    return Promise.resolve();
  }

  const membership = {
    id: Number(plan.value),
    quantity: 1,
    selling_plan: Number(plan.getAttribute('data-selling-plan'))
  };
  const braceletId = offer.getAttribute('data-bracelet-variant');
  const items = braceletId ? [membership, { id: Number(braceletId), quantity: 1 }] : [membership];

  const addItems = list => fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: list })
  }).then(response => response.json().then(data => {
    if (!response.ok) throw data;
    lastCartUpdate = Date.now();
    return data;
  }));

  showVipOfferError(offer, '');
  checkbox.disabled = true;
  offer.classList.add('is-loading');

  // One request for membership + bracelet so the cart sync can't add a second
  // bracelet in between. If the bracelet sold out since the page loaded, add
  // the membership on its own.
  return addItems(items)
    .catch(error => {
      if (items.length === 1) throw error;
      console.warn('Adding membership with bracelet failed, retrying without bracelet:', error);
      freeProductUnavailable = true;
      return addItems([membership]);
    })
    .then(applyVipDiscount)
    .then(() => refreshMiniCart().catch(error => {
      // The membership is in the cart; show it with a full reload instead
      console.error('Could not refresh mini cart after adding VIP:', error);
      window.location.reload();
    }))
    .catch(error => {
      console.error('Error adding VIP membership from mini cart:', error);
      checkbox.checked = false;
      checkbox.disabled = false;
      offer.classList.remove('is-loading');
      showVipOfferError(offer, (error && error.description) || 'Sorry, we couldn\'t add the membership. Please try again.');
    });
}

// GemPages product buttons whose action is "Open cart drawer" hand the shopper
// to window.GPF.openCartDrawer after adding to cart.
function installGemPagesCartHook() {
  window.GPF = window.GPF || {};
  window.GPF.openCartDrawer = function() {
    afterAddToCart();
  };
}

// Easy Donation (snippets/donation.liquid) adds the donation itself, then
// reloads the page. Off the cart page, follow up like any other add (mini
// cart, or "After add to cart" in theme settings) once the page is back.
const DONATION_ADDED_KEY = 'heroDonationAdded';
let donationStartedAt = 0;
let pageUnloading = false;

function isCartPage() {
  return /\/cart\/?$/.test(window.location.pathname);
}

// Called for every cart add; only acts on one the donation widget started
function onDonationAdded() {
  if (!donationStartedAt || Date.now() - donationStartedAt > 15000) return;
  donationStartedAt = 0;
  if (isCartPage()) return;

  try {
    sessionStorage.setItem(DONATION_ADDED_KEY, '1');
  } catch (error) {
    // Storage blocked: the timer below still covers the no-reload case
  }

  // If the app doesn't reload (its thank-you popup is on), don't wait for it
  setTimeout(() => {
    if (pageUnloading) return;
    try {
      sessionStorage.removeItem(DONATION_ADDED_KEY);
    } catch (error) {}
    afterAddToCart();
  }, 1500);
}

// The cart shows each donation as one row, though a custom amount is several
// lines (snippets in header.liquid and cart-template.liquid): remove them all
function removeDonation(productId, fromMiniCart) {
  return withCart(cart => {
    const updates = {};
    cart.items.forEach(item => {
      if (safeString(item.product_id) === productId) updates[item.key] = 0;
    });
    return updateCart(updates);
  })
    .then(() => (fromMiniCart ? refreshMiniCart() : window.location.reload()))
    .catch(error => {
      console.error('Could not remove donation:', error);
      window.location.reload();
    });
}

function watchDonationWidget() {
  // Capture phase, ahead of the theme's own remove handlers
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-remove-donation]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const row = button.closest('[data-cart-item]');
    if (row) row.style.opacity = '0.5';
    removeDonation(button.getAttribute('data-remove-donation'), Boolean(button.closest('[data-cart-form="mini-cart"]')));
  }, true);

  document.addEventListener('submit', event => {
    if (event.target.closest('.donation')) donationStartedAt = Date.now();
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('.donation [type="submit"], .donation button')) donationStartedAt = Date.now();
  }, true);
  window.addEventListener('beforeunload', () => {
    pageUnloading = true;
  });

  let donationAdded = false;
  try {
    donationAdded = sessionStorage.getItem(DONATION_ADDED_KEY) === '1';
    sessionStorage.removeItem(DONATION_ADDED_KEY);
  } catch (error) {}
  if (donationAdded && !isCartPage()) afterAddToCart();
}

window.HeroUnlockFlow = {
  afterAddToCart,
  refreshMiniCart,
  markOfferAdded,
  continueFrom: continueUnlockFlow
};

// Make Memberships Selectable on CO-VIP New page
/** membership-select-only.js.liquid
 * Make Bronze / Silver / Gold cards selectable (visual state + accessibility).
 */
(function () {
    var READY = (document.readyState === 'complete' || document.readyState === 'interactive');
    if (!READY) document.addEventListener('DOMContentLoaded', init);
    else init();
  
    function init() {
      var cards = Array.from(document.querySelectorAll('.vn-membership'));
      if (!cards.length) return;
  
      // Minimal CSS for selected state (non-destructive to theme)
      injectStyles([
        '.vn-membership{cursor:pointer; outline:none; transition:transform .08s ease, box-shadow .12s ease;}',
        '.vn-membership.is-selected{box-shadow:0 0 0 3px rgba(190,214,96,.95), 0 10px 30px rgba(0,0,0,.35); transform:translateY(-1px);} ',
        '.vn-membership:focus-visible{box-shadow:0 0 0 3px rgba(190,214,96,.8);} '
      ].join('\n'));
  
      // Treat the group as radios
      cards.forEach(function (card, idx) {
        card.setAttribute('tabindex', '0');
        card.setAttribute('role', 'radio');
        card.setAttribute('aria-checked', 'false');
  
        // Best-effort label (BRONZE/SILVER/GOLD)
        var label = parseTierLabel(card) || ('Option ' + (idx + 1));
        card.dataset.tierLabel = label;
  
        card.addEventListener('click', function (ev) {
          // Ignore clicks on real buttons/links inside the card
          if (closest(ev.target, 'button,[type="submit"],a,[role="button"]')) return;
          select(card);
        });
  
        card.addEventListener('keydown', function (ev) {
          if (ev.key === 'Enter' || ev.key === ' ') {
            ev.preventDefault();
            select(card);
          }
          // Optional arrow key cycling
          if (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') {
            ev.preventDefault();
            focusNext(cards, card);
          }
          if (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') {
            ev.preventDefault();
            focusPrev(cards, card);
          }
        });
      });
  
      // Default to SILVER (or middle card if labels unknown)
      // var defaultCard =
      //   cards.find(function (c) { return /silver/i.test(c.dataset.tierLabel || ''); }) ||
      //   cards[Math.floor(cards.length / 2)];
      // if (defaultCard) select(defaultCard, true);
  
      function select(target, silent) {
        debugLog("I am selected")
        cards.forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-checked', 'false');
          // Remove variant and selling plan attributes from all cards
          c.removeAttribute('data-variant-id');
          c.removeAttribute('data-selling-plan-id');
        });
        target.classList.add('is-selected');
        target.setAttribute('aria-checked', 'true');
  
        // Expose the current selection to other scripts / CSS if needed
        var value = target.dataset.tierLabel || parseTierLabel(target) || 'selected';
        document.documentElement.setAttribute('data-membership-selected', value.toLowerCase());
        debugLog('value', value);
  
        // Add variant ID and selling plan ID if Silver is selected
        if (value === 'Option 1') {
          target.setAttribute('data-variant-id', '52723800768785');
          target.setAttribute('data-selling-plan-id', '12879560977');
        }
  
        // Add variant ID and selling plan ID if Silver is selected
        if (value === 'Option 2') {
          target.setAttribute('data-variant-id', '52723794116881');
          target.setAttribute('data-selling-plan-id', '12879429905');
        }
  
        // Add variant ID and selling plan ID if Silver is selected
        if (value === 'Option 3') {
          target.setAttribute('data-variant-id', '52723794772241');
          target.setAttribute('data-selling-plan-id', '12879462673');
        }
  
        // Fire a custom event for integrations (no-ops if unused)
        var evt = new CustomEvent('membership:change', { detail: { value: value, el: target } });
        window.dispatchEvent(evt);
  
        if (!silent && navigator.vibrate) { try { navigator.vibrate(8); } catch (e) {} }
      }
  
      function parseTierLabel(cardEl) {
        var text = (cardEl.textContent || '').trim();
        var m = text.match(/\b(BRONZE|SILVER|GOLD)\b/i);
        return m ? m[1].toUpperCase() : null;
      }
  
      function focusNext(list, current) {
        var i = list.indexOf(current);
        var next = list[(i + 1) % list.length];
        next.focus();
      }
      function focusPrev(list, current) {
        var i = list.indexOf(current);
        var prev = list[(i - 1 + list.length) % list.length];
        prev.focus();
      }
  
      function closest(el, sel) {
        while (el && el.nodeType === 1) {
          if (el.matches(sel)) return el;
          el = el.parentElement;
        }
        return null;
      }
  
      function injectStyles(css) {
        var id = 'vn-membership-select-styles';
        if (document.getElementById(id)) return;
        var style = document.createElement('style');
        style.id = id;
        style.textContent = css;
        document.head.appendChild(style);
      }
    }
  })();
  
  

// Initialize when document is ready
$(document).ready(function() {
  debugLog('Enhanced VIP Member Scripts Initialized');
  
  // Run initial sync with delay to ensure DOM is fully loaded
  setTimeout(() => {
    syncFreeProductWithVipStatus();
  }, 500);
  
  // VIP Unlock flow: remember which unlock page this is, so "Once per visit"
  // doesn't show it again on the way to checkout.
  const { currentStep } = unlockFlowSettings();
  if (currentStep) {
    const state = readUnlockState();
    state.seen = Object.assign({}, state.seen, { [currentStep]: true });
    writeUnlockState(state);

    // Ensure cart is properly synced on the unlock pages
    setTimeout(() => {
      syncFreeProductWithVipStatus();
    }, 1000);
  }

  // Holiday priority shipping question (cart page and mini cart). Keep every
  // copy of the question in step and save the answer straight away.
  const PRIORITY_INPUT = 'input[name="attributes[priorityshipping]"]';
  $(document).on('change', PRIORITY_INPUT, function() {
    priorityAnswer = this.value;
    document.querySelectorAll(PRIORITY_INPUT).forEach(input => {
      input.checked = input.value === priorityAnswer;
    });

    // Show the discount change: the cart page's totals are rendered by
    // Liquid, so reload it; the mini cart re-renders in place
    const onCartPage = !!this.closest('#cart_form');
    savePriorityAnswer(priorityAnswer).then(() => {
      if (onCartPage) {
        window.location.reload();
        return;
      }
      return refreshMiniCart().catch(() => window.location.reload());
    });
  });

  // The first time the question shows, record the preselected answer
  const priorityField = document.querySelector('[data-saved-answer=""]');
  const preselected = priorityField && priorityField.querySelector(`${PRIORITY_INPUT}:checked`);
  if (preselected) {
    priorityAnswer = preselected.value;
    savePriorityAnswer(priorityAnswer);
  }

  // VIP mini cart offer. Delegated because the mini cart is re-rendered.
  $(document).on('change', '[data-vip-offer] input[type="radio"]', function() {
    const offer = this.closest('[data-vip-offer]');
    showVipOfferError(offer, '');
    updateVipOffer(offer);
  });

  $(document).on('click', '[data-vip-offer] [data-vip-billing]', function() {
    const offer = this.closest('[data-vip-offer]');
    const billing = this.getAttribute('data-vip-billing');

    offer.querySelectorAll('[data-vip-billing]').forEach(button => {
      button.setAttribute('aria-pressed', String(button === this));
    });
    offer.querySelectorAll('[data-vip-tiers]').forEach(tiers => {
      tiers.hidden = tiers.getAttribute('data-vip-tiers') !== billing;
    });
    updateVipOffer(offer);
  });

  $(document).on('change', '[data-vip-offer] [data-vip-optin]', function() {
    if (this.checked) {
      addVipPlanFromOffer(this.closest('[data-vip-offer]'), this);
    }
  });

  installGemPagesCartHook();
  // GemPages fires this just before it looks the hook up; reinstall in case
  // its runtime replaced window.GPF after we loaded.
  document.addEventListener('gp:open-cart-drawer', installGemPagesCartHook);

  watchDonationWidget();

  // Checkout buttons in the mini cart and on the cart page. Capture phase so
  // the unlock pages are shown before any other checkout handler runs.
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-minicart-checkout-button][name="checkout"], [data-cart-checkout-button]');
    if (!button) return;

    // Leave an unticked terms-of-service checkbox to app.js's warning
    const $terms = $(button).closest('form').find('.tos_agree');
    if ($terms.length && !$terms.is(':checked')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    startCheckout().catch(error => {
      console.error('Error starting checkout:', error);
      window.location.href = CONFIG.redirects.checkout;
    });
  }, true);

  // "Continue" links on the unlock pages move to the next step of the flow
  if (currentStep) {
    document.addEventListener('click', function(event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const link = event.target.closest('a[href], [data-unlock-continue]');
      if (!link || !isUnlockContinueLink(link)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      continueUnlockFlow(currentStep);
    }, true);
  }

  // Add event listener for VIP signup buttons
  $(document).on("click", '.popup_product_add, .membership_signup_btn', function(event) {
    try {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      // The button's own plan (e.g. the cart page VIP popup's "Membership added
      // from the popup" setting), then the selected card on the VIP page
      let variantId = safeGetValue(this, 'data-variant-id') || null;

      const selectedCard = !variantId && safeGetElement('.vn-membership.is-selected');
      if (selectedCard) {
        variantId = safeGetValue(selectedCard, 'data-variant-id');
        debugLog('VIP new page: Found selected card variant:', variantId);
      }
    
      
      
      // Fallback to input field or default variant
      if (!variantId) {
        const variantElement = safeGetElement('input[name="id"]');
        variantId = safeGetValue(variantElement, 'value', CONFIG.vipVariants[0]);
      }
      
      debugLog('VIP signup clicked, variant:', variantId);
      addVipVariantToCart(variantId);
    } catch (error) {
      console.error('Error in VIP signup click:', error);
      jQuery("body").removeClass("disabled-active");
    }
  });
  
  // Add to cart buttons in theme product forms. GemPages product buttons stop
  // the click from reaching here and use installGemPagesCartHook instead.
  $(document).on("click", '.add_to_cart:not([name="checkout"]):not([data-minicart-checkout-button]):not([data-cart-checkout-button])', function(event) {
    try {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const form = this.closest('form');
      const variantField = form && form.querySelector('[name="id"]');
      const variantId = variantField ? safeGetValue(variantField) : safeGetValue(this, 'data-variant-id');

      // Blank while the shopper hasn't picked every option yet
      if (!variantId) {
        showAddToCartWarning(form, (window.PXUTheme.translation && window.PXUTheme.translation.select_variant) || 'Please select an option');
        return;
      }

      debugLog('Add to cart clicked, variant:', variantId);
      jQuery("body").addClass("disabled-active");

      // Check if this is a VIP variant
      if (CONFIG.vipVariants.includes(safeString(variantId))) {
        addVipVariantToCart(variantId);
        return;
      }

      // Regular product - add it, sync free product status, then follow the
      // VIP Unlock flow setting (mini cart or redirect)
      (form ? addFormToCart(form) : addToCart(variantId, 1))
        .then(() => {
          debouncedSync();
          return afterAddToCart();
        })
        .catch(error => {
          console.error('Error adding regular product:', error);
          showAddToCartWarning(form, (error && error.description) || 'There was an issue adding the product to your cart. Please try again.');
        })
        .finally(() => {
          jQuery("body").removeClass("disabled-active");
        });
    } catch (error) {
      console.error('Error in add to cart click:', error);
      jQuery("body").removeClass("disabled-active");
    }
  });

  // Add event listener for HeroVIPClub removal
  // Delegated binding: the mini-cart markup is rebuilt by refreshCart() in app.js
  // on every cart change, so a direct $('.HeroVIPClub').click() would only attach
  // to the elements present at page load and silently stop working after any AJAX
  // cart update. Binding on document keeps it live for re-rendered rows.
  $(document).on('click', '.HeroVIPClub', function(e) {
    try {
      e.preventDefault();

      var title = 'Are you sure you want to remove "Hero VIP Club" from cart?';
      var content = 'This also removes the VIP discount and the free VIP bracelet from your cart.';
      var fromMiniCart = !!this.closest('.cart_content');

      // jquery-confirm loads deferred from a CDN; if it's blocked or slow, fall
      // back to a native confirm so the remove button never becomes a dead click.
      if (typeof $.confirm === 'function') {
        $.confirm({
          title: title,
          content: content,
          buttons: {
            Yes: function() {
              removeVipProductsFromCart(fromMiniCart);
            },
            No: function() {
              // Do nothing
            }
          }
        });
      } else {
        console.warn('$.confirm unavailable, falling back to native confirm');
        if (window.confirm(content)) {
          removeVipProductsFromCart(fromMiniCart);
        }
      }
    } catch (error) {
      console.error('Error in VIP removal click:', error);
    }
  });
  
  // Keep the VIP bracelet in step with the cart whenever it changes
  watchCartRequests();

  // The cart may have changed in another tab, or this page came back from
  // the browser's back/forward cache
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible') debouncedSync();
  });
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) debouncedSync();
  });

  // The cart page renders the VIP upsell banner when the bracelet isn't in
  // the cart yet. If the membership is already there, the sync above adds the
  // bracelet without a reload, so hide the banner now.
  if (jQuery('.cart__item a[href*="hero-vip-club"]').length) {
    jQuery('.outer_vipcustomer_footerbanner').remove();
  }
  
  debugLog('VIP Member Scripts fully initialized with enhanced error handling');
});